import moment from "moment";
type ApiDataFunc<Output> = () => boolean | Output;
export interface IApi<Input = {}, Output = {}> {
  api?: (data: Input) => Promise<Output | undefined>;
  onApiAfter?: (data: Output | boolean) => void;
  onApiBefore?: (data: Input) => Input | boolean | Promise<Input | boolean>;
  data?: Input | boolean | ApiDataFunc<Input>;
  extraApiData?: Partial<Input>;
}
export async function doApi<Input, Output>(
  props: IApi<Input, Output>
): Promise<Output | undefined> {
  let { api, onApiAfter, onApiBefore, data, extraApiData } = props;
  let finalData: Input;
  let output: Output;
  if (data === null || data === false) {
    throw new Error("api data   return false ");
  }
  if (typeof data === "function") {
    let dataFuncResult = (data as ApiDataFunc<Input>)();
    if (typeof dataFuncResult !== "boolean") finalData = dataFuncResult;
    if (!dataFuncResult) throw new Error("api data function has return false ");
  } else if (typeof data !== "boolean") {
    finalData = data;
  }
  if (extraApiData) finalData = Object.assign({}, finalData, extraApiData);
  for (let k in finalData) {
    if (finalData[k] instanceof moment) {
      finalData[k] = (finalData[k] as any)
        .utcOffset(480)
        .format("YYYY-MM-DDTHH:mm:ss");
    } else if (
      Array.isArray(finalData[k]) &&
      finalData[k][0] instanceof moment
    ) {
      finalData[k] = (finalData[k] as any)
        .map((item: any) => item.utcOffset(480).format("YYYY-MM-DDTHH:mm:ss"))
        .join("and");
    }
  }
  if (onApiBefore) {
    let apiResult = await onApiBefore(finalData);
    if (typeof apiResult !== "object")
      throw new Error("on api before has return false");
    finalData = apiResult;
  }

  try {
    output = await api(finalData);
    onApiAfter && onApiAfter(output);
  } catch (ex) {
    onApiAfter && onApiAfter(false);
    throw ex;
  }
  return output;
}

export interface AppAction {
	actionCode?: string
	application?: string
	code?: string
	createdBy?: string
	createdOn?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	moduleId?: number
	name?: string
	parentCode?: string
}

export interface AppAudit {
	actionCode?: string
	actionName?: string
	createTime?: string
	id?: number
	ip?: string
	moduleName?: string
	systemName?: string
	userId?: number
	userName?: string
}

export interface AppConfigParam {
	actionCode?: string
	appConfigParamOptionList?: AppConfigParamOption[]
	application?: string
	createdBy?: string
	createdOn?: string
	describe?: string
	groupId?: number
	id?: number
	keyName?: string
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	scope?: number
	showName?: string
	sort?: string
	type?: number
}

export interface AppConfigParamGroup {
	application?: string
	createdBy?: string
	createdOn?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	showName?: string
	sort?: string
}

export interface AppConfigParamOption {
	application?: string
	configParamId?: number
	createdBy?: string
	createdOn?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	text?: string
	value?: string
}

export interface AppDeleteAction {
	entity?: string
	keyDataType?: string
	keyName?: string
	keyValue?: string
	refItemList?: AppDeleteActionItem[]
	usedItemList?: AppDeleteActionItem[]
}

export interface AppDeleteActionItem {
	entity?: string
	entityName?: string
	refKeyName?: string
}

export interface AppDeleteResult {
	msg?: string
	result?: boolean
}

export interface AppFilter {
	field?: string
	keyName?: string
	list?: string[]
	max?: string
	min?: string
	opr?: string
	searchItemType?: string
	value?: string
}

export interface AppFormAction {
	actionCode?: string
	id?: string
	isDisabled?: boolean
	isHidden?: boolean
	isHighlight?: boolean
	title?: string
}

export interface AppFormBlock {
	appFormItemList?: AppFormItem[]
	colNumber?: number
	isHidden?: boolean
	labelWidth?: number
	title?: string
}

export interface AppFormData {
	entity?: string
	fieldList?: AppFormFieldData[]
	keyName?: string
	keyValue?: number
	metadataId?: string
	mode?: number
	parentId?: number
	tree?: boolean
}

export interface AppFormFieldData {
	changed?: boolean
	dataType?: string
	field?: string
	lable?: string
	save?: boolean
	unAllowSame?: boolean
	unSameScopeField?: string
	value?: string
}

export interface AppFormItem {
	appFormItemOptionLabelField?: string
	appFormItemOptionList?: MetadataOption[]
	appFormItemOptionValueField?: string
	colSpan?: number
	dataSourceType?: string
	dataType?: string
	defaultValue?: string
	error?: string
	field?: string
	forbidChars?: string
	format?: string
	isHidden?: boolean
	isSave?: boolean
	isSaveText?: boolean
	label?: string
	labelHidden?: boolean
	maxLength?: number
	maxNumber?: number
	minNumber?: number
	name?: string
	paramId?: number
	placeholder?: string
	prefix?: string
	prefixField?: string
	readonlyMode?: string
	req?: boolean
	rowSpan?: number
	rows?: number
	sql?: string
	text?: string
	textField?: string
	tips?: string
	type?: string
	unAllowSame?: boolean
	unSameScopeField?: string
	unit?: string
	value?: string
}

export interface AppFormLayout {
	apiPath?: string
	appFormMenu?: AppFormMenu
	appFormTabs?: AppFormTabs
	entityId?: number
	entityName?: string
	keyName?: string
	sqlCommand?: string
	sqlId?: string
	type?: string
}

export interface AppFormMenu {
	appFormActionList?: AppFormAction[]
}

export interface AppFormQuery {
	entity?: string
	keyDataType?: string
	keyName?: string
	keyValue?: string
	sql?: string
	sqlId?: string
}

export interface AppFormResult {
	errorKey?: string
	keyValue?: string
	msg?: string
	result?: boolean
}

export interface AppFormSaveData {
	entity?: string
	itemList?: AppFormSaveItem[]
	keyDataType?: string
	keyName?: string
	keyValue?: string
	mode?: number
	parentId?: string
}

export interface AppFormSaveItem {
	dataType?: string
	field?: string
	keyName?: string
	label?: string
	scopeDataType?: string
	scopeField?: string
	scopeValue?: string
	unRepeat?: boolean
	value?: string
}

export interface AppFormTab {
	appFormBlockList?: AppFormBlock[]
	borderStyle?: number
	isHidden?: boolean
	tabId?: number
	title?: string
}

export interface AppFormTabs {
	appFormTabList?: AppFormTab[]
	defaultTabId?: number
	tabList?: AppFormTab[]
}

export interface AppGridAdvancedSearch {
	appGridAdvancedSearchItemList?: AppGridAdvancedSearchItem[]
	labelWidth?: number
}

export interface AppGridAdvancedSearchItem {
	apiPath?: string
	appGridAdvancedSearchItemOptionList?: MetadataOption[]
	dataType?: string
	field?: string
	keyName?: string
	label?: string
	optionType?: string
	showMoreItem?: boolean
	sql?: string
	type?: string
}

export interface AppGridCommonSearch {
	appGridCommonSearchItemList?: AppGridCommonSearchItem[]
}

export interface AppGridCommonSearchItem {
	dataType?: string
	field?: string
	keyName?: string
	label?: string
}

export interface AppGridHeard {
	appGridMenu?: AppGridMenu
}

export interface AppGridLayout {
	appGridHeard?: AppGridHeard
	appGridSearch?: AppGridSearch
	appGridViewList?: AppGridView[]
	defaultViewId?: number
	entityId?: number
	entityName?: string
}

export interface AppGridMenu {
	appActionList?: AppFormAction[]
}

export interface AppGridSearch {
	appGridAdvancedSearch?: AppGridAdvancedSearch
	appGridCommonSearch?: AppGridCommonSearch
	defaultShowMore?: boolean
	projectFilter?: boolean
	projectFilterField?: string
	projectFilterKeyName?: string
	projectFilterLabel?: string
	projectFilterType?: number
}

export interface AppGridView {
	appTable?: AppTable
	title?: string
	viewId?: number
}

export interface AppModule {
	appActionList?: AppAction[]
	application?: string
	code?: string
	createdBy?: string
	createdOn?: string
	enabled?: number
	fullCode?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	parentCode?: string
	parentId?: number
	sort?: string
	url?: string
}

export interface AppModuleGroup {
	application?: string
	code?: string
	createdBy?: string
	createdOn?: string
	enabled?: number
	fullCode?: string
	icon?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	parentCode?: string
	sort?: string
}

export interface AppOrgan {
	code?: string
	createdBy?: string
	createdOn?: string
	disabled?: boolean
	fullCode?: string
	id?: number
	mdId?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	organType?: number
	parentId?: number
	sapCity?: string
}

export interface AppPage {
	appPageLayoutList?: AppPageLayout[]
	application?: string
	createdBy?: string
	createdOn?: string
	description?: string
	functionCode?: string
	functionPageId?: string
	id?: number
	layoutType?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	pageName?: string
	parentPage?: string
	systemCode?: string
	title?: string
	titleSuffix?: string
	url?: string
}

export interface AppPageLayout {
	application?: string
	height?: number
	id?: string
	metadataId?: number
	type?: string
	width?: number
}

export interface AppParam {
	actionCode?: string
	application?: string
	createdBy?: string
	createdOn?: string
	describe?: string
	groupId?: number
	id?: number
	keyName?: string
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	pageUrl?: string
	paramType?: number
	scope?: number
	showName?: string
	sort?: string
}

export interface AppParamGroup {
	application?: string
	createdBy?: string
	createdOn?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	showName?: string
	sort?: string
}

export interface AppParamOutput {
	appConfigParamGroupList?: AppConfigParamGroup[]
	appConfigParamList?: AppConfigParam[]
	appParamGroupList?: AppParamGroup[]
	appParamList?: AppParam[]
}

export interface AppPermissions {
	actionList?: string[]
	systemList?: SystemVo[]
}

export interface AppRole {
	createdBy?: string
	createdOn?: string
	id?: number
	isAdmin?: number
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	remarks?: string
}

export interface AppSearchData {
	dataType?: string
	field?: string[]
	itemType?: string
	keyName?: string
	maxValue?: string
	minValue?: string
	value?: string
	valueList?: string[]
}

export interface AppSystem {
	application?: string
	code?: string
	createdBy?: string
	createdOn?: string
	enabled?: number
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	sort?: string
}

export interface AppTable {
	apiPath?: string
	appTableColList?: AppTableCol[]
	appTableParamList?: AppTableParam[]
	colActionWidth?: number
	multiSelect?: boolean
	paging?: boolean
	showIndexColumn?: boolean
	sqlCommand?: string
	sqlId?: string
	tableActionList?: AppFormAction[]
	type?: string
}

export interface AppTableCol {
	field?: string
	fixed?: string
	title?: string
	width?: number
}

export interface AppTableList {
	list?: object[]
	total?: number
}

export interface AppTableParam {
	field?: string
	value?: string
}

export interface AppTableQuery {
	filterList?: AppFilter[]
	orderBy?: string
	page?: number
	paging?: boolean
	size?: number
	sql?: string
	sqlId?: string
}

export interface AppTreeDTO {
	allowSelect?: boolean
	dataType?: string
	fullCode?: string
	fullName?: string
	id?: number
	isEnd?: number
	level?: number
	name?: string
	parentId?: number
}

export interface AppTreeData {
	fullCode?: string
	level?: number
	parentId?: number
}

export interface AppUser {
	account?: string
	adUser?: boolean
	companyId?: number
	createdBy?: string
	createdOn?: string
	disabled?: boolean
	email?: string
	gender?: string
	id?: number
	mobile?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	organId?: number
}

export interface AppUserMemory {
	createdBy?: string
	createdOn?: string
	dataName?: string
	dataValue?: number
	id?: number
	modifiedBy?: string
	modifiedOn?: string
	scene?: number
	userId?: number
}

export interface AppletReqInput {
	tel1?: string
	zj_NUM?: string
}

export interface AppletReqOutput {
	aofyname?: string
	fund_ACTUAL?: string
	fund_name?: string
	hkbz?: string
	pjurl?: string
	ssrq?: string
	status?: string
	stkdbkey?: string
}

export interface Attach {
	createdBy?: string
	createdOn?: string
	id?: number
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	refId?: string
	refType?: string
	status?: string
	url?: string
}

export interface BankInfo {
	aofq?: string
	aold?: string
	aoxm?: string
	bankl?: string
	bankn?: string
	db_KEY?: string
	fund_CODE?: string
	fund_TYPE?: string
	hbkid?: string
	hktid?: string
	id?: string
	zbanka?: string
}

export interface ChangePasswordInput {
	password?: string
	userId?: number
}

export interface CnarrayOutput {
	gwList?: GW[]
	khList?: KH[]
	order?: Order
	ysList?: YS[]
}

export interface ComponentDto {
	application?: string
	id?: number
	isLeaf?: boolean
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	type?: string
	typeEnum?: number
}

export interface CreatereceiptHeaderInput {
	aofy?: string
	aoxm?: string
	bp?: string
	bpname?: string
	fptype?: string
	fundActual?: string
	fundActualTax?: string
	fundname?: string
	kpDate?: string
	kpname?: string
	kptime?: string
	pjno?: string
	pjpch?: string
	pjurl?: string
	poskey?: string
	rcid?: string
	rectype?: string
	remark?: string
	status?: string
	transacactionID?: string
}

export interface CreatereceiptInput {
	header?: CreatereceiptHeaderInput
	itemList?: CreatereceiptItemInput[]
}

export interface CreatereceiptItemInput {
	fundActual?: string
	fundActualTax?: string
	poskey?: string
	stkdbkey?: string
	zsl?: string
	zsm?: string
}

export interface CreatereceiptOutput {
	poskey?: string
	recdbkey?: string
	shortlog?: string
	state?: string
}

export interface CreatestkOutput {
	bcznj?: string
	db_KEY?: string
	db_KEY_HEX?: string
	ifdzsj?: string
	ifznj?: string
	positem_ID?: string
	shortlog?: string
	skjh_NUM?: string
	ssjl_NUM?: string
	state?: string
	zsk_NUM?: string
}

export interface CreatestkReqInput {
	aofq?: string
	aofy?: string
	aoxm?: string
	bank_ID?: string
	bankn?: string
	bukrs?: string
	custnum?: string
	db_KEY?: string
	fk_BANKID?: string
	fk_BANKName?: string
	fk_NAME?: string
	fund_ACTUAL?: string
	fund_ACTUAL_TAX?: string
	fund_CODE?: string
	fund_TYPE?: string
	hbkid?: string
	hktid?: string
	ifpos?: string
	ifzs?: string
	order_TYPE?: string
	parent_KEY?: string
	pos_ID?: string
	pos_NUMB?: string
	pos_URL?: string
	positem_ID?: string
	possxf?: string
	rcid1?: string
	rec_ID?: string
	rec_TYPE?: string
	skjh_NUM?: string
	ssrq?: string
	transacactionid?: string
	type?: string
	waerk?: string
	zsl?: string
	zsm?: string
	zsszt?: string
}

export interface Custom {
	cust_NAME?: string
	custnum?: string
	tel1?: string
	zj_NUM?: string
	zj_TYPE?: string
}

export interface EntAuthInput {
	appId?: string
	customerId?: string
	serialNo?: string
	status?: string
	statusDesc?: string
}

export interface EnterpriseRcb {
	createdBy?: string
	createdOn?: string
	customerId?: string
	id?: number
	isApplyCert?: number
	isCertificate?: number
	isDelete?: number
	isEnrolment?: number
	modifiedBy?: string
	modifiedOn?: string
	openId?: string
	openName?: string
	personUrl?: string
	projectId?: number
	status?: string
	transactionNo?: string
}

export interface EnterpriseRcbInput {
	ids?: number[]
	projectId?: number
}

export interface EntitySearch {
	name?: string
	orderBy?: string
	page?: number
	paging?: boolean
	size?: number
	sqlId?: string
	systemCode?: string
}

export interface ErpProjectInput {
	erpProjectOutputList?: ErpProjectOutput[]
	organId?: number
}

export interface ErpProjectOutput {
	parentId?: string
	posId?: string
	post1?: string
	sapCity?: string
	stufe?: string
}

export interface FormSaveResult {
	field?: string
	keyValue?: number
	msg?: string
	result?: boolean
}

export interface GW {
	bname?: string
	parent_KEY?: string
	posnr?: string
	zgwlx?: string
	zygw_NAME?: string
}

export interface GenerateWebBillInput {
	preview?: number
	templateId?: number
	voucherId?: number
}

export interface HouseOutput {
	aofyname?: string
	ponum?: string
	zfjnm?: string
	zsl?: string
	zsm?: string
	zszdy?: string
}

export interface HouseSearch {
	orderBy?: string
	page?: number
	paging?: boolean
	posId?: string
	size?: number
	sqlId?: string
}

export interface HttpResult {
	data?: object
	msg?: string
	result?: boolean
}

export interface KH {
	cust_NAME?: string
	custnum?: string
	number?: number
	parent_KEY?: string
	tel1?: string
	zj_NUM?: string
	zj_TYPE?: string
}

export interface LoginInput {
	account?: string
	entCode?: string
	password?: string
	rememberMe?: boolean
	systemCode?: string
}

export interface LoginOutput {
	expirationDate?: string
	permissions?: AppPermissions
	token?: string
	userId?: number
	userName?: string
}

export interface LoginResult {
	data?: LoginOutput
	msg?: string
	result?: boolean
}

export interface MdmPermissionInput {
	id?: number
	list?: number[]
	mode?: string
}

export interface MdmProject {
	code?: string
	createdBy?: string
	createdOn?: string
	fullCode?: string
	id?: number
	mdId?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	organId?: number
	parentId?: number
	podParentId?: string
	posId?: string
	sapCity?: string
	stufe?: string
}

export interface MetadataAttribute {
	alias?: string
	attributeType?: string
	columnNumber?: number
	dbType?: string
	displayName?: string
	id?: number
	isNullable?: boolean
	isPrimaryAttribute?: boolean
	isSystem?: boolean
	length?: number
	name?: string
}

export interface MetadataEntity {
	application?: string
	createdBy?: string
	createdOn?: string
	displayName?: string
	id?: number
	isSystem?: boolean
	metadataAttributeList?: MetadataAttribute[]
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	primaryKey?: string
}

export interface MetadataForm {
	appFormLayout?: AppFormLayout
	application?: string
	createdBy?: string
	createdOn?: string
	description?: string
	formData?: object
	functionPageId?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
}

export interface MetadataGrid {
	appGridLayout?: AppGridLayout
	application?: string
	createdBy?: string
	createdOn?: string
	description?: string
	functionPageId?: string
	id?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
}

export interface MetadataOption {
	label?: string
	value?: string
}

export interface MetadataView {
	application?: string
	createdBy?: string
	createdOn?: string
	displayName?: string
	id?: number
	metadataAttributeList?: MetadataAttribute[]
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	sqlText?: string
}

export interface MetadataViewIn {
	displayName?: string
	name?: string
	sqlText?: string
	systemCode?: string
}

export interface ModelingPageSearch {
	apiPath?: string
	appSearchDataList?: AppSearchData[]
	application?: string
	id?: number
	idField?: string
	orderBy?: string
	page?: number
	pageId?: number
	paging?: boolean
	size?: number
	sql?: string
	sqlId?: string
	viewId?: number
}

export interface ModuleGrid {
	application?: string
	code?: string
	createdBy?: string
	createdOn?: string
	enabled?: number
	fullCode?: string
	icon?: string
	id?: number
	isEnd?: number
	level?: number
	metadataVersion?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	parentCode?: string
	parentId?: number
	showCode?: string
	sort?: string
	url?: string
}

export interface ModuleGroupVo {
	enabled?: number
	fullCode?: string
	icon?: string
	moduleList?: ModuleVo[]
	name?: string
}

export interface ModuleVo {
	enabled?: number
	fullCode?: string
	name?: string
	url?: string
}

export interface Order {
	actual_NUMBER?: string
	aofy?: string
	aofyname?: string
	aold?: string
	auart?: string
	busks?: string
	db_KEY?: string
	ifbg?: string
	overdue?: string
	paper_VBELN?: string
	transacactionID?: string
	vbeln?: string
	zsl?: string
	zsm?: string
}

export interface OrderInputT {
	tel1?: string
	type?: string
	zjnum?: string
	zprojectno?: string
}

export interface PageList {
	list?: object[]
	total?: number
}

export interface PageListOfHouseOutput {
	list?: HouseOutput[]
	total?: number
}

export interface PageListOfMetadataEntity {
	list?: MetadataEntity[]
	total?: number
}

export interface PageListOfMetadataView {
	list?: MetadataView[]
	total?: number
}

export interface PageListOfModuleGrid {
	list?: ModuleGrid[]
	total?: number
}

export interface PosAppBank {
	bankName?: string
	bankNumber?: string
	erpBankId?: string
	id?: number
}

export interface PosAppBankIuput {
	erpFeeIds?: string[]
	erpTradeId?: string
	fundId?: number
	mac?: string
	projectId?: number
	roomCode?: string
	scene?: string
}

export interface PosAppCustomer {
	erpId?: string
	name?: string
	tel?: string
	zjNumber?: string
	zjType?: string
}

export interface PosAppFee {
	actualNumber?: string
	aofy?: string
	aoxm?: string
	customer?: PosAppCustomer
	erpId?: string
	erpTradeId?: string
	fundActual?: number
	fundAmount?: number
	fundCode?: string
	fundName?: string
	ifbg?: number
	rcId?: string
	roomName?: string
	skjhNum?: string
	transactionId?: string
	vbeln?: string
	ye?: number
	ysrq?: string
}

export interface PosAppFeeOutput {
	amount?: number
	createdOn?: string
	electronicBillUrl?: string
	fundName?: string
	id?: number
	voucherId?: number
}

export interface PosAppGenerateBillInput {
	getInFeeIdList?: number[]
	preview?: number
	projectId?: number
	remarks?: string
	templateId?: number
}

export interface PosAppGetinFeeIuput {
	amount?: number
	erpFeeId?: string
}

export interface PosAppGetinIuput {
	amount?: number
	amt?: string
	aofy?: string
	aoxm?: string
	appName?: string
	bankCancelInfo?: string
	bankInfo?: string
	bankName?: string
	bankNumber?: string
	batchNo?: string
	cardIssuer?: string
	cardNo?: string
	chinaPayRefId?: string
	date?: string
	erpBankId?: string
	erpCustomerId?: string
	extOrderNo?: string
	fundId?: number
	getinFeeList?: PosAppGetinFeeIuput[]
	handler?: string
	id?: number
	mac?: string
	merchantName?: string
	merchantNo?: string
	payMode?: string
	payNo?: string
	payer?: string
	posBankId?: number
	posCode?: string
	posGetInCustomerList?: PosGetInCustomer[]
	projectId?: number
	rcId?: string
	refId?: string
	refNo?: string
	resCode?: string
	scene?: string
	settleDate?: string
	skjhNum?: string
	terminalNo?: string
	time?: string
	traceNo?: string
	transId?: string
	transactionId?: string
}

export interface PosAppMdmDyOutput {
	fjList?: PosAppMdmFj[]
	name?: string
}

export interface PosAppMdmFj {
	dyName?: string
	name?: string
	sapId?: string
	zfjnm?: string
}

export interface PosAppMdmFqOutput {
	ldList?: PosAppMdmLd[]
	name?: string
	sapId?: string
}

export interface PosAppMdmLd {
	fqSapId?: string
	name?: string
	sapId?: string
}

export interface PosAppPrintTemplate {
	id?: number
	sealName?: string
	templateName?: string
}

export interface PosAppProjectOutput {
	id?: number
	name?: string
}

export interface PosAppTrade {
	actualNumber?: string
	auart?: string
	auartName?: string
	customer?: PosAppCustomer
	erpId?: string
	feeList?: PosAppFee[]
	ifbg?: string
	roomName?: string
	vbeln?: string
}

export interface PosAppTradeOutput {
	bankList?: PosAppBank[]
	customer?: PosCustomer
	feeList?: PosAppFee[]
	tradeList?: PosAppTrade[]
}

export interface PosAppVerifyPasswordInput {
	mac?: string
	password?: string
	projectId?: string
}

export interface PosAppZskOption {
	createdBy?: string
	createdOn?: string
	fullCode?: string
	fundCode?: string
	fundFullName?: string
	fundName?: string
	fundTypeName?: string
	id?: number
	isPos?: number
	isZsk?: number
	itemClass?: number
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	parentId?: number
	posAppScene?: string
	type?: number
}

export interface PosAppZskOutput {
	bankList?: PosAppBank[]
	customer?: PosCustomer
	customerList?: PosAppCustomer[]
	fundName?: string
	zskOptionList?: PosAppZskOption[]
}

export interface PosBankSelectInput {
	id?: number
	ids?: number[]
}

export interface PosBankSetDefaultInput {
	id?: number
	projectId?: number
}

export interface PosBankUpdateInput {
	id?: number
	isOn?: number
}

export interface PosBillInput {
	id?: number
	key?: string
	keys?: string
	type?: string
}

export interface PosCustomer {
	createdBy?: string
	createdOn?: string
	erpId?: string
	id?: number
	idNumber?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	password?: string
	tell?: string
	zjType?: string
	zjTypeCode?: string
}

export interface PosCustomerSeachor {
	idNumber?: string
	projectId?: number
	scene?: string
	tell?: string
}

export interface PosDevice {
	createdBy?: string
	createdOn?: string
	id?: number
	mac?: string
	modifiedBy?: string
	modifiedOn?: string
	name?: string
	projectId?: number
	remark?: string
	version?: string
}

export interface PosFund {
	createdBy?: string
	createdOn?: string
	fundCode?: string
	fundFullName?: string
	fundName?: string
	fundTypeName?: string
	id?: number
	isPos?: number
	isZsk?: number
	itemClass?: number
	modifiedBy?: string
	modifiedOn?: string
	posAppScene?: string
	type?: number
}

export interface PosGetIn {
	amount?: number
	amt?: string
	appName?: string
	bankName?: string
	bankNumber?: string
	batchNo?: string
	billNo?: string
	billUrl?: string
	cancelBy?: string
	cancelOn?: string
	cancelUserCode?: string
	cardIssuer?: string
	cardNo?: string
	chinaPayRefId?: string
	createdBy?: string
	createdOn?: string
	date?: string
	erpBankId?: string
	erpCustomerId?: string
	extOrderNo?: string
	id?: number
	isCancel?: number
	isEffective?: number
	mac?: string
	merchantName?: string
	merchantNo?: string
	modifiedBy?: string
	modifiedOn?: string
	networkStatus?: number
	oprCode?: string
	payMode?: string
	payNo?: string
	payResult?: number
	payer?: string
	posBankId?: number
	posCode?: string
	projectId?: number
	pssxf?: string
	refId?: string
	refNo?: string
	resCode?: string
	roomInfo?: string
	scene?: string
	settleDate?: string
	syncCancelStatus?: number
	syncStatus?: number
	terminalNo?: string
	time?: string
	traceNo?: string
	transId?: string
}

export interface PosGetInCustomer {
	customerName?: string
	erpCustomerId?: string
	getInId?: number
	id?: number
	sequence?: number
	tel?: string
	zjNumber?: string
	zjType?: string
}

export interface PosGetInFee {
	amount?: number
	bankName?: string
	bankNumber?: string
	erpCustomerId?: string
	erpFeeId?: string
	erpFqId?: string
	erpId?: string
	erpProjectId?: string
	erpRoomId?: string
	erpSsNum?: string
	erpTradeId?: string
	fundActualTax?: number
	fundCode?: string
	fundName?: string
	fundType?: string
	getInId?: number
	id?: number
	isCancel?: number
	networkStatus?: number
	rcId?: string
	roomInfo?: string
	ssjlNm?: string
	sxf?: string
	sxfSyncStatus?: number
	syncCancelStatus?: number
	syncStatus?: number
	transacactionId?: string
	voucherLockTime?: string
	voucherUsedLock?: number
	zsl?: number
	zsm?: string
}

export interface PosGetInOutput {
	allCustomerName?: string
	posCustomer?: PosCustomer
	posGetIn?: PosGetIn
	posGetInFees?: PosGetInFee[]
}

export interface PosLoginInput {
	account?: string
	id?: number
	mac?: string
	password?: string
	version?: string
}

export interface PosLoginOutput {
	projectList?: PosAppProjectOutput[]
	token?: string
	userId?: number
	userName?: string
}

export interface PosLoginResult {
	data?: PosLoginOutput
	msg?: string
	result?: boolean
}

export interface PosManagerPasswordInput {
	id?: number
	password?: string
}

export interface PosMerchant {
	businessName?: string
	createdBy?: string
	createdOn?: string
	erpBankId?: string
	id?: number
	managerPassword?: string
	merchantCode?: string
	merchantCodeScan?: string
	merchantName?: string
	modifiedBy?: string
	modifiedOn?: string
	projectId?: number
}

export interface PosProjectFundReplace {
	fundId?: number
	id?: number
	projectId?: number
	replaceName?: string
}

export interface PosProjectFundTax {
	fundId?: number
	id?: number
	isTax?: number
	projectId?: number
}

export interface PosProjectFundVo {
	fullCode?: string
	id?: number
	isTax?: number
	mode?: number
	name?: string
	parentId?: number
	replaceId?: number
	replaceName?: string
	taxId?: number
}

export interface PosProjectInput {
	id?: number
	ids?: number[]
}

export interface PosResult {
	data?: object
	returnCode?: string
	returnMsg?: string
}

export interface PosSAPStkInput {
	getInId?: number
	possxf?: string
	type?: string
}

export interface PosVoucher {
	amount?: number
	aofy?: string
	aoxm?: string
	billNo?: string
	bp?: string
	bpName?: string
	cancelBy?: string
	cancelDate?: string
	cancelOn?: string
	cancelUserCode?: string
	downloadFdd?: string
	electronicBillUrl?: string
	erpId?: string
	id?: number
	isCancel?: number
	isEffective?: number
	jkr?: string
	kpDate?: string
	kpr?: string
	kprUserCode?: string
	mode?: string
	projectId?: number
	rcId?: string
	remarks?: string
	roomInfo?: string
	skr?: string
	skrUserCode?: string
	status?: number
	syncCancelStatus?: number
	syncStatus?: number
	transacactionId?: string
	zjCode?: string
}

export interface PosVoucherCreateInput {
	getInFeeIdList?: number[]
	mode?: string
	preview?: number
	projectId?: number
	remarks?: string
}

export interface ReversestkOutput {
	shortlog?: string
	state?: string
}

export interface ReversestkReqInput {
	aoxm?: string
	db_KEY?: string
	positem_ID?: string
	ssjl_NUM?: string
	type?: string
}

export interface RoleActionInput {
	actionCodeList?: string[]
	roleId?: number
}

export interface SmsVo {
	code?: string
	idNumber?: string
	password?: string
	tel?: string
}

export interface SystemVo {
	code?: string
	current?: boolean
	enabled?: number
	moduleGroupList?: ModuleGroupVo[]
	name?: string
}

export interface TempSealInput {
	posId?: string
}

export interface TemplateOption {
	id?: number
	sealName?: string
	templateName?: string
}

export interface UserRoleInput {
	id?: number
	ids?: number[]
	mode?: string
}

export interface WisdomCashierSeal {
	createdBy?: string
	createdOn?: string
	customerId?: string
	id?: number
	isDelete?: number
	isEnabled?: number
	modifiedBy?: string
	modifiedOn?: string
	projectId?: number
	remark?: string
	sealCode?: string
	sealName?: string
	sealUrl?: string
	status?: string
}

export interface WisdomCashierTemplate {
	createdBy?: string
	createdOn?: string
	erpTempId?: string
	fileName?: string
	id?: number
	isDelete?: number
	isEnabled?: number
	modifiedBy?: string
	modifiedOn?: string
	printCount?: string
	printStyle?: string
	printType?: string
	projectId?: number
	sealId?: number
	templatUrl?: string
	templateName?: string
}

export interface WxEmailInputVo {
	billId?: string
	email?: string
	idNumber?: string
	roomName?: string
	stkdbkeyJson?: string
	tel1?: string
}

export interface WxHouseInputVo {
	billId?: string
	customerName?: string
	idNumber?: string
	roomName?: string
	stkdbkeyList?: string[]
	tel1?: string
}

export interface YS {
	aofy?: string
	aofyname?: string
	aoxm?: string
	db_KEY?: string
	fund_ACTUAL?: string
	fund_AMOUNT?: string
	fund_CODE?: string
	fund_TYPE?: string
	order_TYPE?: string
	ponum?: string
	rcid1?: string
	seq_NUM?: string
	skjh_NUM?: string
	transacactionID?: string
	ygznj?: string
	ysrq?: string
	zszdy?: string
}
import http from 'services/http'
export default {
  apporgan: {
    authorize(permissionInput: MdmPermissionInput): Promise<HttpResult> {
      return http.post('/api/appOrgan/authorize', permissionInput).then(res => res.data)
    },
    create(organ: AppOrgan): Promise<AppFormResult> {
      return http.post('/api/appOrgan/create', organ).then(res => res.data)
    },
    delete(organ: AppOrgan): Promise<AppFormResult> {
      return http.post('/api/appOrgan/delete', organ).then(res => res.data)
    },
    disabled(organ: AppOrgan): Promise<AppFormResult> {
      return http.post('/api/appOrgan/disabled', organ).then(res => res.data)
    },
    enabled(organ: AppOrgan): Promise<AppFormResult> {
      return http.post('/api/appOrgan/enabled', organ).then(res => res.data)
    },
    getList(): Promise<AppOrgan[]> {
      return http.get('/api/appOrgan/getList').then(res => res.data)
    },
    getOne(params: { id: number }): Promise<AppOrgan> {
      return http.get('/api/appOrgan/getOne', { params }).then(res => res.data)
    },
    getUserAuthorizeOrgan(params: { id: number }): Promise<number[]> {
      return http.get('/api/appOrgan/getUserAuthorizeOrgan', { params }).then(res => res.data)
    },
    update(organ: AppOrgan): Promise<AppFormResult> {
      return http.post('/api/appOrgan/update', organ).then(res => res.data)
    },
  },
  appuser: {
    changePassword(user: ChangePasswordInput): Promise<HttpResult> {
      return http.post('/api/appUser/changePassword', user).then(res => res.data)
    },
    create(user: AppUser): Promise<AppFormResult> {
      return http.post('/api/appUser/create', user).then(res => res.data)
    },
    delete(user: AppUser): Promise<HttpResult> {
      return http.post('/api/appUser/delete', user).then(res => res.data)
    },
    disable(params: { id: number }): Promise<HttpResult> {
      return http.get('/api/appUser/disable', { params }).then(res => res.data)
    },
    enable(params: { id: number }): Promise<HttpResult> {
      return http.get('/api/appUser/enable', { params }).then(res => res.data)
    },
    getCurrUser(): Promise<AppUser> {
      return http.get('/api/appUser/getCurrUser').then(res => res.data)
    },
    getOne(params: { userId: number }): Promise<AppUser> {
      return http.get('/api/appUser/getOne', { params }).then(res => res.data)
    },
    isAdmin(): Promise<boolean> {
      return http.get('/api/appUser/isAdmin').then(res => res.data)
    },
    update(user: AppUser): Promise<AppFormResult> {
      return http.post('/api/appUser/update', user).then(res => res.data)
    },
    updateUserInfo(user: AppUser): Promise<AppUser> {
      return http.post('/api/appUser/updateUserInfo', user).then(res => res.data)
    },
  },
  audit: {
    save(appAudit: AppAudit): Promise<HttpResult> {
      return http.post('/api/audit/save', appAudit).then(res => res.data)
    },
  },
  electronicbill: {
    create(params: { getInId: number }): Promise<HttpResult> {
      return http.get('/api/electronicBill/create', { params }).then(res => res.data)
    },
  },
  mdmproject: {
    authorize(permissionInput: MdmPermissionInput): Promise<HttpResult> {
      return http.post('/api/mdmProject/authorize', permissionInput).then(res => res.data)
    },
    delete(params: { id: number }): Promise<HttpResult> {
      return http.post('/api/mdmProject/delete', {}, { params }).then(res => res.data)
    },
    getErpProjectList(erpProjectInput: ErpProjectInput): Promise<HttpResult> {
      return http.post('/api/mdmProject/getErpProjectList', erpProjectInput).then(res => res.data)
    },
    getErpXmList(params: { organId: number }): Promise<ErpProjectOutput[]> {
      return http.get('/api/mdmProject/getErpXmList', { params }).then(res => res.data)
    },
    getOne(params: { id: number }): Promise<MdmProject> {
      return http.get('/api/mdmProject/getOne', { params }).then(res => res.data)
    },
    getUserAuthorizeProject(params: { id: number }): Promise<number[]> {
      return http.get('/api/mdmProject/getUserAuthorizeProject', { params }).then(res => res.data)
    },
  },
  modeling: {
    appform: {
      getList(metadataForm: MetadataForm): Promise<MetadataForm[]> {
        return http.post('/api/modeling/appForm/getList', metadataForm).then(res => res.data)
      },
      getOne(params: { id?: number, pageId?: number }): Promise<MetadataForm> {
        return http.get('/api/modeling/appForm/getOne', { params }).then(res => res.data)
      },
      getOneXml(metadataForm: MetadataForm): Promise<string> {
        return http.post('/api/modeling/appForm/getOneXml', metadataForm).then(res => res.data)
      },
      getParentData(params: { entity: string, parentId: number }): Promise<AppTreeData> {
        return http.get('/api/modeling/appForm/getParentData', { params }).then(res => res.data)
      },
      loadData(params: { id?: number, pageId?: number }): Promise<object> {
        return http.get('/api/modeling/appForm/loadData', { params }).then(res => res.data)
      },
      save(appFormData: AppFormData): Promise<FormSaveResult> {
        return http.post('/api/modeling/appForm/save', appFormData).then(res => res.data)
      },
    },
    appgrid: {
      delSql(params: { sql?: string }): Promise<string> {
        return http.get('/api/modeling/appGrid/delSql', { params }).then(res => res.data)
      },
      getList(metadataGrid: MetadataGrid): Promise<MetadataGrid[]> {
        return http.post('/api/modeling/appGrid/getList', metadataGrid).then(res => res.data)
      },
      getOne(metadataGrid: MetadataGrid): Promise<MetadataGrid> {
        return http.post('/api/modeling/appGrid/getOne', metadataGrid).then(res => res.data)
      },
      getOneDesiger(metadataGrid: MetadataGrid): Promise<MetadataGrid> {
        return http.post('/api/modeling/appGrid/getOneDesiger', metadataGrid).then(res => res.data)
      },
      loadData(modelingPageSearch: ModelingPageSearch): Promise<PageList> {
        return http.post('/api/modeling/appGrid/loadData', modelingPageSearch).then(res => res.data)
      },
      save(metadataGrid: MetadataGrid): Promise<MetadataGrid> {
        return http.post('/api/modeling/appGrid/save', metadataGrid).then(res => res.data)
      },
    },
    apppage: {
      GetModuleOrComponent(params: { application?: string, id?: number, isLeaf?: boolean, modifiedBy?: string, modifiedOn?: string, name?: string, type?: string, typeEnum?: number }): Promise<ComponentDto[]> {
        return http.post('/api/modeling/appPage/GetModuleOrComponent', {}, { params }).then(res => res.data)
      },
      getComponentList(params: { application?: string }): Promise<ComponentDto[]> {
        return http.post('/api/modeling/appPage/getComponentList', {}, { params }).then(res => res.data)
      },
      getList(params: { application?: string }): Promise<AppPage[]> {
        return http.post('/api/modeling/appPage/getList', {}, { params }).then(res => res.data)
      },
      getOne(appPage: AppPage): Promise<AppPage> {
        return http.post('/api/modeling/appPage/getOne', appPage).then(res => res.data)
      },
      getOneDesiger(appPage: AppPage): Promise<AppPage> {
        return http.post('/api/modeling/appPage/getOneDesiger', appPage).then(res => res.data)
      },
      save(appPage: AppPage): Promise<AppPage> {
        return http.post('/api/modeling/appPage/save', appPage).then(res => res.data)
      },
    },
    entity: {
      createTable(metadataEntity: MetadataEntity): Promise<MetadataEntity> {
        return http.post('/api/modeling/entity/createTable', metadataEntity).then(res => res.data)
      },
      createView(metadataViewIn: MetadataViewIn): Promise<MetadataView> {
        return http.post('/api/modeling/entity/createView', metadataViewIn).then(res => res.data)
      },
      getAttrBySql(metadataViewIn: MetadataViewIn): Promise<MetadataAttribute[]> {
        return http.post('/api/modeling/entity/getAttrBySql', metadataViewIn).then(res => res.data)
      },
      getList(entitySearch: EntitySearch): Promise<MetadataEntity[]> {
        return http.post('/api/modeling/entity/getList', entitySearch).then(res => res.data)
      },
      getOne(metadataEntity: MetadataEntity): Promise<MetadataEntity> {
        return http.post('/api/modeling/entity/getOne', metadataEntity).then(res => res.data)
      },
      getPageList(entitySearch: EntitySearch): Promise<PageListOfMetadataEntity> {
        return http.post('/api/modeling/entity/getPageList', entitySearch).then(res => res.data)
      },
      getViewList(entitySearch: EntitySearch): Promise<MetadataView[]> {
        return http.post('/api/modeling/entity/getViewList', entitySearch).then(res => res.data)
      },
      getViewPageList(entitySearch: EntitySearch): Promise<PageListOfMetadataView> {
        return http.post('/api/modeling/entity/getViewPageList', entitySearch).then(res => res.data)
      },
      newId(): Promise<number> {
        return http.get('/api/modeling/entity/newId').then(res => res.data)
      },
      updateTable(metadataEntity: MetadataEntity): Promise<MetadataEntity> {
        return http.post('/api/modeling/entity/updateTable', metadataEntity).then(res => res.data)
      },
      updateView(metadataView: MetadataView): Promise<MetadataView> {
        return http.post('/api/modeling/entity/updateView', metadataView).then(res => res.data)
      },
    },
    module: {
      getAllGroupList(params: { systemCode: string }): Promise<AppModuleGroup[]> {
        return http.get('/api/modeling/module/getAllGroupList', { params }).then(res => res.data)
      },
      getAllModuleList(params: { systemCode: string }): Promise<AppModule[]> {
        return http.get('/api/modeling/module/getAllModuleList', { params }).then(res => res.data)
      },
      getGroup(params: { id: number, systemCode: string }): Promise<AppModuleGroup> {
        return http.get('/api/modeling/module/getGroup', { params }).then(res => res.data)
      },
      getModule(params: { id: number, systemCode: string }): Promise<AppModule> {
        return http.get('/api/modeling/module/getModule', { params }).then(res => res.data)
      },
      getModuleGrid(params: { systemCode: string }): Promise<PageListOfModuleGrid> {
        return http.get('/api/modeling/module/getModuleGrid', { params }).then(res => res.data)
      },
      getModuleGroupList(params: { systemCode: string }): Promise<ModuleGrid[]> {
        return http.get('/api/modeling/module/getModuleGroupList', { params }).then(res => res.data)
      },
      getSystemList(): Promise<AppSystem[]> {
        return http.get('/api/modeling/module/getSystemList').then(res => res.data)
      },
      saveAction(appModule: AppModule): Promise<HttpResult> {
        return http.post('/api/modeling/module/saveAction', appModule).then(res => res.data)
      },
      saveModule(appModule: AppModule): Promise<HttpResult> {
        return http.post('/api/modeling/module/saveModule', appModule).then(res => res.data)
      },
      saveModuleGroup(appModuleGroup: AppModuleGroup): Promise<HttpResult> {
        return http.post('/api/modeling/module/saveModuleGroup', appModuleGroup).then(res => res.data)
      },
    },
    param: {
      getData(params: { systemCode: string }): Promise<AppParamOutput> {
        return http.get('/api/modeling/param/getData', { params }).then(res => res.data)
      },
      saveConfigParam(appConfigParam: AppConfigParam): Promise<HttpResult> {
        return http.post('/api/modeling/param/saveConfigParam', appConfigParam).then(res => res.data)
      },
      saveConfigParamGroup(appConfigParamGroup: AppConfigParamGroup): Promise<HttpResult> {
        return http.post('/api/modeling/param/saveConfigParamGroup', appConfigParamGroup).then(res => res.data)
      },
      saveParam(appParam: AppParam): Promise<HttpResult> {
        return http.post('/api/modeling/param/saveParam', appParam).then(res => res.data)
      },
      saveParamGroup(appParamGroup: AppParamGroup): Promise<HttpResult> {
        return http.post('/api/modeling/param/saveParamGroup', appParamGroup).then(res => res.data)
      },
    },
  },
  posapp: {
    LockPostGetInFeeLock(posVoucherCreateInput: PosVoucherCreateInput): Promise<HttpResult> {
      return http.post('/api/posApp/LockPostGetInFeeLock', posVoucherCreateInput).then(res => res.data)
    },
    addAppGetIn(getinIuput: PosAppGetinIuput): Promise<PosAppGetinIuput> {
      return http.post('/api/posApp/addAppGetIn', getinIuput).then(res => res.data)
    },
    asyncStateMentDetail(): Promise<HttpResult> {
      return http.get('/api/posApp/asyncStateMentDetail').then(res => res.data)
    },
    beforeCancelPay(getinIuput: PosAppGetinIuput): Promise<HttpResult> {
      return http.post('/api/posApp/beforeCancelPay', getinIuput).then(res => res.data)
    },
    cancelPay(getinIuput: PosAppGetinIuput): Promise<HttpResult> {
      return http.post('/api/posApp/cancelPay', getinIuput).then(res => res.data)
    },
    checkVoucherStatus(posVoucherCreateInput: PosVoucherCreateInput): Promise<HttpResult> {
      return http.post('/api/posApp/checkVoucherStatus', posVoucherCreateInput).then(res => res.data)
    },
    generateBill(posAppGenerateBillInput: PosAppGenerateBillInput): Promise<HttpResult> {
      return http.post('/api/posApp/generateBill', posAppGenerateBillInput).then(res => res.data)
    },
    getBankByScene(posAppBankIuput: PosAppBankIuput): Promise<PosAppBank[]> {
      return http.post('/api/posApp/getBankByScene', posAppBankIuput).then(res => res.data)
    },
    getBillImgByVoucherId(posVoucher: PosVoucher): Promise<HttpResult> {
      return http.post('/api/posApp/getBillImgByVoucherId', posVoucher).then(res => res.data)
    },
    getChinaPayRefKey(): Promise<string> {
      return http.get('/api/posApp/getChinaPayRefKey').then(res => res.data)
    },
    getCreatereceipt(params: { voucherId: number }): Promise<HttpResult> {
      return http.post('/api/posApp/getCreatereceipt', {}, { params }).then(res => res.data)
    },
    getCreatestk(posSAPStkInput: PosSAPStkInput): Promise<HttpResult> {
      return http.post('/api/posApp/getCreatestk', posSAPStkInput).then(res => res.data)
    },
    getDyList(params: { sapId?: string }): Promise<PosAppMdmDyOutput[]> {
      return http.get('/api/posApp/getDyList', { params }).then(res => res.data)
    },
    getFee(customerSeachor: PosCustomerSeachor): Promise<PosAppTradeOutput> {
      return http.post('/api/posApp/getFee', customerSeachor).then(res => res.data)
    },
    getFeeByScene(posGetIn: PosGetIn): Promise<PosAppFeeOutput[]> {
      return http.post('/api/posApp/getFeeByScene', posGetIn).then(res => res.data)
    },
    getFqList(params: { id?: number }): Promise<PosAppMdmFqOutput[]> {
      return http.get('/api/posApp/getFqList', { params }).then(res => res.data)
    },
    getFund(getinIuput: PosAppGetinIuput): Promise<HttpResult> {
      return http.post('/api/posApp/getFund', getinIuput).then(res => res.data)
    },
    getGetInByFeeId(params: { erpId: string }): Promise<PosGetInOutput[]> {
      return http.get('/api/posApp/getGetInByFeeId', { params }).then(res => res.data)
    },
    getManagerInfo(verifyPasswordInput: PosAppVerifyPasswordInput): Promise<HttpResult> {
      return http.post('/api/posApp/getManagerInfo', verifyPasswordInput).then(res => res.data)
    },
    getPosAppPrintTemplate(params: { projectId: number }): Promise<PosAppPrintTemplate[]> {
      return http.get('/api/posApp/getPosAppPrintTemplate', { params }).then(res => res.data)
    },
    getPosGetInByPosCode(params: { posCode: string }): Promise<PosGetInOutput> {
      return http.get('/api/posApp/getPosGetInByPosCode', { params }).then(res => res.data)
    },
    getPosGetInByRefNo(params: { refNo: string }): Promise<PosGetInOutput> {
      return http.get('/api/posApp/getPosGetInByRefNo', { params }).then(res => res.data)
    },
    getPosGetInByTraceNo(params: { traceNo: string }): Promise<PosGetInOutput> {
      return http.get('/api/posApp/getPosGetInByTraceNo', { params }).then(res => res.data)
    },
    getPosGetInListByCus(posCustomerSeachor: PosCustomerSeachor): Promise<PosGetInOutput[]> {
      return http.post('/api/posApp/getPosGetInListByCus', posCustomerSeachor).then(res => res.data)
    },
    getProject(params: { account?: string, id?: number, mac?: string, password?: string, version?: string }): Promise<PosAppProjectOutput[]> {
      return http.get('/api/posApp/getProject', { params }).then(res => res.data)
    },
    getReversestkState(posSAPStkInput: PosSAPStkInput): Promise<ReversestkOutput> {
      return http.post('/api/posApp/getReversestkState', posSAPStkInput).then(res => res.data)
    },
    getZskFee(customerSeachor: PosCustomerSeachor): Promise<PosAppZskOutput> {
      return http.post('/api/posApp/getZskFee', customerSeachor).then(res => res.data)
    },
    handlePayError(getinIuput: PosAppGetinIuput): Promise<HttpResult> {
      return http.post('/api/posApp/handlePayError', getinIuput).then(res => res.data)
    },
    handlePaySuccess(getinIuput: PosAppGetinIuput): Promise<HttpResult> {
      return http.post('/api/posApp/handlePaySuccess', getinIuput).then(res => res.data)
    },
    syncProject(params: { account?: string, id?: number, mac?: string, password?: string, version?: string }): Promise<PosAppProjectOutput[]> {
      return http.get('/api/posApp/syncProject', { params }).then(res => res.data)
    },
    verifyPassword(verifyPasswordInput: PosAppVerifyPasswordInput): Promise<HttpResult> {
      return http.post('/api/posApp/verifyPassword', verifyPasswordInput).then(res => res.data)
    },
  },
  posbank: {
    delete(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posBank/delete', { params }).then(res => res.data)
    },
    getBanksByProjectId(params: { projectId?: number }): Promise<HttpResult> {
      return http.get('/api/posBank/getBanksByProjectId', { params }).then(res => res.data)
    },
    setDefault(posBankSetDefaultInput: PosBankSetDefaultInput): Promise<HttpResult> {
      return http.post('/api/posBank/setDefault', posBankSetDefaultInput).then(res => res.data)
    },
    upDatePosBank(posBankUpdateInput: PosBankUpdateInput): Promise<HttpResult> {
      return http.post('/api/posBank/upDatePosBank', posBankUpdateInput).then(res => res.data)
    },
  },
  posdevice: {
    delete(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posDevice/delete', { params }).then(res => res.data)
    },
    deleteProgram(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posDevice/deleteProgram', { params }).then(res => res.data)
    },
    getListByProject(params: { id?: number }): Promise<PosDevice[]> {
      return http.get('/api/posDevice/getListByProject', { params }).then(res => res.data)
    },
  },
  posenterprisercb: {
    certificate(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
      return http.post('/api/posEnterpriseRcb/certificate', enterpriseRcb).then(res => res.data)
    },
    create(enterpriseRcb: EnterpriseRcb): Promise<AppFormResult> {
      return http.post('/api/posEnterpriseRcb/create', enterpriseRcb).then(res => res.data)
    },
    delete(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
      return http.post('/api/posEnterpriseRcb/delete', enterpriseRcb).then(res => res.data)
    },
    enrolment(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
      return http.post('/api/posEnterpriseRcb/enrolment', enterpriseRcb).then(res => res.data)
    },
    getApplyCert(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
      return http.post('/api/posEnterpriseRcb/getApplyCert', enterpriseRcb).then(res => res.data)
    },
    getEntOptions(params: { projectId?: number }): Promise<MetadataOption[]> {
      return http.post('/api/posEnterpriseRcb/getEntOptions', {}, { params }).then(res => res.data)
    },
    getOne(params: { id?: number }): Promise<EnterpriseRcb> {
      return http.get('/api/posEnterpriseRcb/getOne', { params }).then(res => res.data)
    },
    getintroduceList(params: { intProjectId?: number, projectId?: number }): Promise<EnterpriseRcb[]> {
      return http.post('/api/posEnterpriseRcb/getintroduceList', {}, { params }).then(res => res.data)
    },
    handleStatus(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
      return http.post('/api/posEnterpriseRcb/handleStatus', enterpriseRcb).then(res => res.data)
    },
    introduceList(enterpriseRcbInput: EnterpriseRcbInput): Promise<HttpResult> {
      return http.post('/api/posEnterpriseRcb/introduceList', enterpriseRcbInput).then(res => res.data)
    },
    update(enterpriseRcb: EnterpriseRcb): Promise<AppFormResult> {
      return http.post('/api/posEnterpriseRcb/update', enterpriseRcb).then(res => res.data)
    },
  },
  posfund: {
    create(posFund: PosFund): Promise<AppFormResult> {
      return http.post('/api/posFund/create', posFund).then(res => res.data)
    },
    delete(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posFund/delete', { params }).then(res => res.data)
    },
    getOne(params: { id?: number }): Promise<PosFund> {
      return http.get('/api/posFund/getOne', { params }).then(res => res.data)
    },
    setCancelZsk(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posFund/setCancelZsk', { params }).then(res => res.data)
    },
    setCancelZskList(params: { ids?: string }): Promise<HttpResult> {
      return http.get('/api/posFund/setCancelZskList', { params }).then(res => res.data)
    },
    setPosSxf(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posFund/setPosSxf', { params }).then(res => res.data)
    },
    setZsk(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posFund/setZsk', { params }).then(res => res.data)
    },
    setZskList(params: { ids?: string }): Promise<HttpResult> {
      return http.get('/api/posFund/setZskList', { params }).then(res => res.data)
    },
    update(posFund: PosFund): Promise<AppFormResult> {
      return http.post('/api/posFund/update', posFund).then(res => res.data)
    },
  },
  posmerchant: {
    addBank(input: PosBankSelectInput): Promise<HttpResult> {
      return http.post('/api/posMerchant/addBank', input).then(res => res.data)
    },
    addProject(posProjectInput: PosProjectInput): Promise<HttpResult> {
      return http.post('/api/posMerchant/addProject', posProjectInput).then(res => res.data)
    },
    delete(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posMerchant/delete', { params }).then(res => res.data)
    },
    getBankOptions(params: { id?: number }): Promise<MetadataOption[]> {
      return http.get('/api/posMerchant/getBankOptions', { params }).then(res => res.data)
    },
    getDeviceOptions(params: { id?: number }): Promise<MetadataOption[]> {
      return http.get('/api/posMerchant/getDeviceOptions', { params }).then(res => res.data)
    },
    getOne(params: { id?: number }): Promise<PosMerchant> {
      return http.get('/api/posMerchant/getOne', { params }).then(res => res.data)
    },
    getProjectBankOptions(params: { projectId?: number }): Promise<MetadataOption[]> {
      return http.get('/api/posMerchant/getProjectBankOptions', { params }).then(res => res.data)
    },
    removeBank(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posMerchant/removeBank', { params }).then(res => res.data)
    },
    removeDevice(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posMerchant/removeDevice', { params }).then(res => res.data)
    },
    removeProject(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/posMerchant/removeProject', { params }).then(res => res.data)
    },
    setManagerPassword(input: PosManagerPasswordInput): Promise<HttpResult> {
      return http.post('/api/posMerchant/setManagerPassword', input).then(res => res.data)
    },
  },
  posprojectfund: {
    getProjectFundVoList(params: { projectId?: number }): Promise<PosProjectFundVo[]> {
      return http.get('/api/posProjectFund/getProjectFundVoList', { params }).then(res => res.data)
    },
    setProjectFundTax(posProjectFundTax: PosProjectFundTax): Promise<HttpResult> {
      return http.post('/api/posProjectFund/setProjectFundTax', posProjectFundTax).then(res => res.data)
    },
    setReplaceName(fundReplace: PosProjectFundReplace): Promise<HttpResult> {
      return http.post('/api/posProjectFund/setReplaceName', fundReplace).then(res => res.data)
    },
  },
  posvoucher: {
    create(input: PosVoucherCreateInput): Promise<HttpResult> {
      return http.post('/api/posVoucher/create', input).then(res => res.data)
    },
  },
  posgetinfee: {
    exportRevokedBillList(appTableQuery: AppTableQuery): Promise<string> {
      return http.post('/api/posgetinfee/exportRevokedBillList', appTableQuery).then(res => res.data)
    },
    exportValidBillList(appTableQuery: AppTableQuery): Promise<string> {
      return http.post('/api/posgetinfee/exportValidBillList', appTableQuery).then(res => res.data)
    },
  },
  public: {
    account: {
      login(loginInput: LoginInput): Promise<LoginResult> {
        return http.post('/api/public/account/login', loginInput).then(res => res.data)
      },
    },
    component: {
      delEntity(deleteAction: AppDeleteAction): Promise<AppDeleteResult> {
        return http.post('/api/public/component/delEntity', deleteAction).then(res => res.data)
      },
      getAppTreeList(params: { scene: number }): Promise<AppTreeDTO[]> {
        return http.get('/api/public/component/getAppTreeList', { params }).then(res => res.data)
      },
      getFormData(appFormQuery: AppFormQuery): Promise<object> {
        return http.post('/api/public/component/getFormData', appFormQuery).then(res => res.data)
      },
      getOptions(params: { scene: string }): Promise<MetadataOption[]> {
        return http.get('/api/public/component/getOptions', { params }).then(res => res.data)
      },
      getTableList(appTableQuery: AppTableQuery): Promise<AppTableList> {
        return http.post('/api/public/component/getTableList', appTableQuery).then(res => res.data)
      },
      getValue(params: { scene: number }): Promise<AppUserMemory> {
        return http.get('/api/public/component/getValue', { params }).then(res => res.data)
      },
      saveForm(appFormSaveData: AppFormSaveData): Promise<AppFormResult> {
        return http.post('/api/public/component/saveForm', appFormSaveData).then(res => res.data)
      },
      setValue(appUserMemory: AppUserMemory): Promise<AppUserMemory> {
        return http.post('/api/public/component/setValue', appUserMemory).then(res => res.data)
      },
    },
    delAttach(params: { id: number }): Promise<HttpResult> {
      return http.post('/api/public/delAttach', {}, { params }).then(res => res.data)
    },
    download(params: { fileName: string, filePath: string }): Promise<string> {
      return http.get('/api/public/download', { params }).then(res => res.data)
    },
    downloadAttach(params: { id: number }): Promise<string> {
      return http.get('/api/public/downloadAttach', { params }).then(res => res.data)
    },
    emailinterface: {
      send(): Promise<HttpResult> {
        return http.get('/api/public/emailInterface/send').then(res => res.data)
      },
    },
    fdd: {
      companyRegisterCallback(entAuthInput: EntAuthInput): Promise<HttpResult> {
        return http.post('/api/public/fdd/companyRegisterCallback', entAuthInput).then(res => res.data)
      },
      findVerifyInfo(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
        return http.post('/api/public/fdd/findVerifyInfo', enterpriseRcb).then(res => res.data)
      },
      getApplyCert(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
        return http.post('/api/public/fdd/getApplyCert', enterpriseRcb).then(res => res.data)
      },
      register(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
        return http.post('/api/public/fdd/register', enterpriseRcb).then(res => res.data)
      },
      verGetCompanyUrl(enterpriseRcb: EnterpriseRcb): Promise<HttpResult> {
        return http.post('/api/public/fdd/verGetCompanyUrl', enterpriseRcb).then(res => res.data)
      },
    },
    getAttachByIds(params: { id: number }): Promise<Attach> {
      return http.get('/api/public/getAttachByIds', { params }).then(res => res.data)
    },
    getAttachList(params: { id?: number, refId?: string, refType?: string }): Promise<Attach[]> {
      return http.get('/api/public/getAttachList', { params }).then(res => res.data)
    },
    getBillUrlKey(params: { id?: number }): Promise<string> {
      return http.get('/api/public/getBillUrlKey', { params }).then(res => res.data)
    },
    getContractImgageUrl(params: { id?: number }): Promise<string> {
      return http.get('/api/public/getContractImgageUrl', { params }).then(res => res.data)
    },
    httpsDownload(params: { fileName: string, filePath: string }): Promise<string> {
      return http.get('/api/public/httpsDownload', { params }).then(res => res.data)
    },
    possap: {
      getAppletCallSap(input: AppletReqInput): Promise<AppletReqOutput[]> {
        return http.post('/api/public/pos-sap/getAppletCallSap', input).then(res => res.data)
      },
      getBankInfoList(params: { AOXM: string }): Promise<BankInfo[]> {
        return http.get('/api/public/pos-sap/getBankInfoList', { params }).then(res => res.data)
      },
      getCreatereceipt(input: CreatereceiptInput): Promise<CreatereceiptOutput> {
        return http.post('/api/public/pos-sap/getCreatereceipt', input).then(res => res.data)
      },
      getCreatestk(createstkReqInput: CreatestkReqInput): Promise<CreatestkOutput> {
        return http.post('/api/public/pos-sap/getCreatestk', createstkReqInput).then(res => res.data)
      },
      getCustomList(orderInput: OrderInputT): Promise<Custom[]> {
        return http.post('/api/public/pos-sap/getCustomList', orderInput).then(res => res.data)
      },
      getHouseList(houseSearch: HouseSearch): Promise<PageListOfHouseOutput> {
        return http.post('/api/public/pos-sap/getHouseList', houseSearch).then(res => res.data)
      },
      getHouseListByPosId(params: { posId?: string }): Promise<HouseOutput[]> {
        return http.get('/api/public/pos-sap/getHouseListByPosId', { params }).then(res => res.data)
      },
      getOrderList(orderInput: OrderInputT): Promise<CnarrayOutput[]> {
        return http.post('/api/public/pos-sap/getOrderList', orderInput).then(res => res.data)
      },
      getPosTempSeal(tempSealInput: TempSealInput): Promise<HttpResult> {
        return http.post('/api/public/pos-sap/getPosTempSeal', tempSealInput).then(res => res.data)
      },
      getReversestkState(input: ReversestkReqInput): Promise<ReversestkOutput> {
        return http.post('/api/public/pos-sap/getReversestkState', input).then(res => res.data)
      },
    },
    posapp: {
      login(loginInput: PosLoginInput): Promise<PosLoginResult> {
        return http.post('/api/public/posApp/login', loginInput).then(res => res.data)
      },
    },
    printBill(posBillInput: PosBillInput): Promise<HttpResult> {
      return http.post('/api/public/printBill', posBillInput).then(res => res.data)
    },
    saptask: {
      syncGetCreatestkTask(): Promise<HttpResult> {
        return http.get('/api/public/saptask/syncGetCreatestkTask').then(res => res.data)
      },
      syncgetCreatereceiptTask(): Promise<HttpResult> {
        return http.get('/api/public/saptask/syncgetCreatereceiptTask').then(res => res.data)
      },
    },
    statement: {
      getStatementFromFtp(params: { date?: string }): Promise<HttpResult> {
        return http.get('/api/public/statement/getStatementFromFtp', { params }).then(res => res.data)
      },
    },
    upload(params: { directory?: string }): Promise<string> {
      return http.post('/api/public/upload', {}, { params }).then(res => res.data)
    },
    uploadAttach(params: { directory?: string, refId?: string, refType?: string }): Promise<string> {
      return http.post('/api/public/uploadAttach', {}, { params }).then(res => res.data)
    },
    uploadImage(): Promise<string> {
      return http.post('/api/public/uploadImage', {}).then(res => res.data)
    },
    uploadSeal(): Promise<string> {
      return http.post('/api/public/uploadSeal', {}).then(res => res.data)
    },
    uploadTicketTemplate(): Promise<string> {
      return http.post('/api/public/uploadTicketTemplate', {}).then(res => res.data)
    },
    wxcustomer: {
      getUserInfoByIdNumber(params: { idNumber: string, tel: string }): Promise<HttpResult> {
        return http.get('/api/public/wxcustomer/getUserInfoByIdNumber', { params }).then(res => res.data)
      },
      login(params: { idNumber: string, password: string }): Promise<HttpResult> {
        return http.get('/api/public/wxcustomer/login', { params }).then(res => res.data)
      },
      updateUserPasswordByPhone(params: { password: string, tel: string }): Promise<HttpResult> {
        return http.get('/api/public/wxcustomer/updateUserPasswordByPhone', { params }).then(res => res.data)
      },
      updateUserTelByIdNumber(params: { idNumber: string, oldTel: string, tel: string }): Promise<HttpResult> {
        return http.get('/api/public/wxcustomer/updateUserTelByIdNumber', { params }).then(res => res.data)
      },
    },
    wxhouse: {
      getBillImgUrl(wxHouseInputVo: WxHouseInputVo): Promise<string> {
        return http.post('/api/public/wxhouse/getBillImgUrl', wxHouseInputVo).then(res => res.data)
      },
      getHouseList(wxHouseInputVo: WxHouseInputVo): Promise<HttpResult> {
        return http.post('/api/public/wxhouse/getHouseList', wxHouseInputVo).then(res => res.data)
      },
      getRoomInfo(wxHouseInputVo: WxHouseInputVo): Promise<HttpResult> {
        return http.post('/api/public/wxhouse/getRoomInfo', wxHouseInputVo).then(res => res.data)
      },
      getRoomList(wxHouseInputVo: WxHouseInputVo): Promise<HttpResult> {
        return http.post('/api/public/wxhouse/getRoomList', wxHouseInputVo).then(res => res.data)
      },
      getRoomListByName(wxHouseInputVo: WxHouseInputVo): Promise<HttpResult> {
        return http.post('/api/public/wxhouse/getRoomListByName', wxHouseInputVo).then(res => res.data)
      },
    },
    wxsendemail: {
      sendEmail(inputVo: WxEmailInputVo): Promise<HttpResult> {
        return http.post('/api/public/wxsendemail/sendEmail', inputVo).then(res => res.data)
      },
    },
    wxsendsms: {
      setSingleSms(vo: SmsVo): Promise<HttpResult> {
        return http.post('/api/public/wxsendsms/setSingleSms', vo).then(res => res.data)
      },
      validate(vo: SmsVo): Promise<HttpResult> {
        return http.post('/api/public/wxsendsms/validate', vo).then(res => res.data)
      },
    },
  },
  role: {
    addUserRole(userRoleInput: UserRoleInput): Promise<HttpResult> {
      return http.post('/api/role/addUserRole', userRoleInput).then(res => res.data)
    },
    authorizeActions(roleActionInput: RoleActionInput): Promise<HttpResult> {
      return http.post('/api/role/authorizeActions', roleActionInput).then(res => res.data)
    },
    deleteRole(role: AppRole): Promise<AppRole> {
      return http.post('/api/role/deleteRole', role).then(res => res.data)
    },
    deleteUserRole(params: { id?: number }): Promise<number> {
      return http.get('/api/role/deleteUserRole', { params }).then(res => res.data)
    },
    getRoleActionCodeList(params: { id?: number }): Promise<string[]> {
      return http.get('/api/role/getRoleActionCodeList', { params }).then(res => res.data)
    },
  },
  security: {
    getPermissions(params: { systemCode?: string }): Promise<AppPermissions> {
      return http.get('/api/security/getPermissions', { params }).then(res => res.data)
    },
  },
  unionpayinfo: {
    getUnionpayInfo(jsonObject: object): Promise<HttpResult> {
      return http.post('/api/unionpayInfo/getUnionpayInfo', jsonObject).then(res => res.data)
    },
  },
  v4: {
    posactual: {
      getActualDate(): Promise<PosResult> {
        return http.post('/api/v4/posActual/getActualDate', {}).then(res => res.data)
      },
      handleActualBankList(): Promise<PosResult> {
        return http.get('/api/v4/posActual/handleActualBankList').then(res => res.data)
      },
    },
  },
  wisdomcashierseal: {
    UploadSeal(wisdomCashierSeal: WisdomCashierSeal): Promise<HttpResult> {
      return http.post('/api/wisdomCashierSeal/UploadSeal', wisdomCashierSeal).then(res => res.data)
    },
    create(wisdomCashierSeal: WisdomCashierSeal): Promise<AppFormResult> {
      return http.post('/api/wisdomCashierSeal/create', wisdomCashierSeal).then(res => res.data)
    },
    delete(wisdomCashierSeal: WisdomCashierSeal): Promise<HttpResult> {
      return http.post('/api/wisdomCashierSeal/delete', wisdomCashierSeal).then(res => res.data)
    },
    disable(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/wisdomCashierSeal/disable', { params }).then(res => res.data)
    },
    enable(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/wisdomCashierSeal/enable', { params }).then(res => res.data)
    },
    getOne(params: { id?: number }): Promise<WisdomCashierSeal> {
      return http.get('/api/wisdomCashierSeal/getOne', { params }).then(res => res.data)
    },
    getSealOptions(params: { projectId?: number }): Promise<MetadataOption[]> {
      return http.get('/api/wisdomCashierSeal/getSealOptions', { params }).then(res => res.data)
    },
    update(wisdomCashierSeal: WisdomCashierSeal): Promise<AppFormResult> {
      return http.post('/api/wisdomCashierSeal/update', wisdomCashierSeal).then(res => res.data)
    },
  },
  wisdomcashiertemplate: {
    GenerateBill(input: GenerateWebBillInput): Promise<HttpResult> {
      return http.post('/api/wisdomCashierTemplate/GenerateBill', input).then(res => res.data)
    },
    create(wisdomCashierTemplate: WisdomCashierTemplate): Promise<AppFormResult> {
      return http.post('/api/wisdomCashierTemplate/create', wisdomCashierTemplate).then(res => res.data)
    },
    delete(wisdomCashierTemplate: WisdomCashierTemplate): Promise<HttpResult> {
      return http.post('/api/wisdomCashierTemplate/delete', wisdomCashierTemplate).then(res => res.data)
    },
    disable(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/wisdomCashierTemplate/disable', { params }).then(res => res.data)
    },
    enable(params: { id?: number }): Promise<HttpResult> {
      return http.get('/api/wisdomCashierTemplate/enable', { params }).then(res => res.data)
    },
    getOne(params: { id?: number }): Promise<WisdomCashierTemplate> {
      return http.get('/api/wisdomCashierTemplate/getOne', { params }).then(res => res.data)
    },
    getTemplateOptions(params: { projectId?: number }): Promise<TemplateOption[]> {
      return http.get('/api/wisdomCashierTemplate/getTemplateOptions', { params }).then(res => res.data)
    },
    update(wisdomCashierTemplate: WisdomCashierTemplate): Promise<AppFormResult> {
      return http.post('/api/wisdomCashierTemplate/update', wisdomCashierTemplate).then(res => res.data)
    },
	  // getFileTypeOptions(id?: number): Promise<HttpResult> {
	  // 	return http.get(`/api/posEnterpriseRcb/getFddFileType?sealCode=${id}`).then(res => res.data)
	  // }
	  getFileTypeOptions(params: { sealId ? : string } ): Promise<MetadataOption[]> {
		  return http.get(`/api/posEnterpriseRcb/getFddFileType`, { params }).then(res => res.data)
	  }
  },
}


// WEBPACK FOOTER //
// ./src/api/index.ts